import React, {useCallback, useState} from 'react'
import ListItemText from '@mui/material/ListItemText'
import {Chip} from '@mui/material'
import ListItem from '@mui/material/ListItem'
import StyledCheckbox from '@/components/pages/NewDatasetJobPage/StyledCheckbox'
import Grid from '@mui/material/GridLegacy'
import styled from 'styled-components'
import {StringFilterOptions} from '@/components/pages/NewDatasetJobPage/types'
import StyledTextField from '@/components/pages/NewDatasetJobPage/StyledTextField'
import FractionNonMissingTooltip from '@/components/common/FractionNonMissingTooltip'

const StyledChip = styled(Chip)`
    margin-right: 0.25em;
    margin-bottom: 0.25em
`

type StringFilterItemProps = {
    stringFilterOpts: StringFilterOptions
    checked: boolean
    onFilterSelect: (filterName: string, checked: boolean, filterVal: any) => void
    selectedValues?: string[]
}

const StringFilterItem = ({stringFilterOpts, checked, onFilterSelect, selectedValues}: StringFilterItemProps) => {

    const [inputValue, setInputValue] = useState<string>('')

    const onCheck = useCallback(() => {
        if (checked) {
            onFilterSelect(stringFilterOpts.name, false, undefined)
        } else {
            onFilterSelect(stringFilterOpts.name, true, [])
        }
    }, [checked, stringFilterOpts])

    const handleChipSelect = useCallback((value: string) => {
        if (selectedValues && selectedValues.includes(value)) {
            onFilterSelect(stringFilterOpts.name, true, [...selectedValues.filter(val => val !== value).map(val => val)])
        } else {
            const vals = selectedValues ? [...selectedValues, value] : [value]
            onFilterSelect(stringFilterOpts.name, true, vals)
        }
    }, [selectedValues, stringFilterOpts])
    
    const handleInput = useCallback((evt: any) => {
        setInputValue(evt.target.value)
    }, [])

    const handleInputEnter = useCallback((evt: any) => {
        if(evt.key === 'Enter') {
            let newValueArr = selectedValues ? [...selectedValues] : []
            if(inputValue.includes(';')) {
                newValueArr = newValueArr.concat(inputValue.split(';'))
            } else {
                newValueArr.push(inputValue)
            }
            setInputValue('')
            onFilterSelect(stringFilterOpts.name, true, newValueArr)
        }
    }, [inputValue, selectedValues, onFilterSelect])

    return (
        <ListItem disablePadding>
            <Grid container spacing={2} paddingRight={1}>
                <Grid item xs={4} display="flex" alignItems="center">
                    <StyledCheckbox checked={checked} onClick={onCheck}/>
                    <FractionNonMissingTooltip fraction={stringFilterOpts.fraction_non_missing}>
                        <ListItemText
                            primary={stringFilterOpts.name}/>
                    </FractionNonMissingTooltip>
                </Grid>
                <Grid item xs={8}>
                    {stringFilterOpts.freeText ? <>
                        <Grid item xs={12} paddingBottom={1}>
                            {selectedValues?.map((val, valIdx) => (
                                <StyledChip key={'string-filter-chip-btn-' + valIdx}
                                    color={'primary'}
                                    variant={'filled'}
                                    label={val}
                                    onDelete={() => handleChipSelect(val)}
                                />
                            ))}
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} paddingBottom={1}>
                            <StyledTextField
                                id="excludedPhenoFilterFields"
                                label="Excluded pheno filter fields"
                                size="small"
                                required
                                fullWidth
                                value={inputValue}
                                onChange={handleInput}
                                onKeyUp={handleInputEnter}
                                helperText="Press enter to confirm input. You can also use semicolon ; as delimiter for multi input."/>
                        </Grid>
                    </>
                        :
                        stringFilterOpts.distinct_values?.filter(val => !!val).map((val, valIdx) => (
                            <StyledChip key={'string-filter-chip-btn-' + valIdx}
                                color={selectedValues && selectedValues.includes(val!) ? 'primary' : 'default'}
                                variant={selectedValues && selectedValues.includes(val!) ? 'filled' : 'outlined'}
                                label={val}
                                onClick={() => handleChipSelect(val!)}/>
                        ))
                    }
                </Grid>
            </Grid>
        </ListItem>
    )
}

export default StringFilterItem